import GlobalVariables from "../GlobalVariables";


const addStyleTextInIframe = (text, id, before, dom) => {
    try {

        let cssNode = null;
        const defaultSheetId = 'apexchat_default_iframeCss';
        id = id || defaultSheetId;
        cssNode = dom.getElementById(id);
        if (!cssNode) {
            cssNode = dom.createElement('style');
            cssNode.type = 'text/css';
            cssNode.rel = 'stylesheet';
            cssNode.media = 'screen';
            if (id) {
                cssNode.id = id;
            }
        }
        // running cache of styles so we don't query the dom; fixes a bug in <= IE7 where dom querying blows up
        if (!GlobalVariables.iframeStyles[id]) {
            GlobalVariables.iframeStyles[id] = '';
        }
        GlobalVariables.iframeStyles[id] += text;

        if (cssNode.styleSheet) {
            cssNode.styleSheet.cssText = GlobalVariables.iframeStyles[id];
        } else {
            cssNode.appendChild(dom.createTextNode(text));
        }
        if (window.ApexChat.nonceValue) {
            cssNode.nonce = window.ApexChat.nonceValue;
        }
        if (before) {
            dom.getElementsByTagName('head')[0].insertBefore(
                cssNode,
                dom.getElementsByTagName('head')[0].firstChild
            );
        } else {
            dom.getElementsByTagName('head')[0].appendChild(cssNode);
        }
    } catch (ex) {
        if (window.console) {
            window.console.error(ex);
        }
    }
};
export default addStyleTextInIframe;
